const IMAGE_EXTENSIONS = ['.jpeg', '.jpg', '.png', '.webp'];
const POPUP_GALLERIES = document.querySelectorAll('.light-gallery');
const PAGE_GALLERY = document.querySelector('.page-light-gallery');
const POPUP_AJAX_GALLERIES = document.querySelectorAll('.ajax-light-gallery');
const POPUP_VIDEO = document.getElementById('video-light-gallery');

const isImage = (link) => IMAGE_EXTENSIONS.some((ext) => link.indexOf(ext) !== -1);

const getScrollbarWidth = () => {
  const documentWidth = parseInt(document.documentElement.clientWidth);
  const windowWidth = parseInt(window.innerWidth);
  return windowWidth - documentWidth;
};

const setCompensationMargin = (scrollbarWidth, overflow) => {
  const scrollbarWidthInt = parseInt(scrollbarWidth);
  const headerBlock = document.querySelector('.header__top-block');
  headerBlock.style.marginRight = `${scrollbarWidthInt}px`;
  document.documentElement.style.cssText = `margin-right: ${scrollbarWidthInt}px; overflow: ${overflow}`
};

const openLightGallery = (element, imageList) => {
  const galleryOptions = {
    plugins: [lgZoom, lgAutoplay],
    slideShowAutoplay: 1000,
    dynamic: true,
    dynamicEl: [],
    mobileSettings: {
      showCloseIcon: true
    },
    addClass: 'ap-ignore-deep'
  };

  if (imageList.length > 0) {
    setCompensationMargin(getScrollbarWidth(), 'hidden');

    imageList.map((image) => {
      galleryOptions.dynamicEl.push(image)
    });

    if (imageList.length === 1) galleryOptions.autoplay = false;

    const dynamicGallery = lightGallery(element, galleryOptions);

    const removeGallery = () => {
      dynamicGallery.destroy();
      setCompensationMargin(0, 'auto');
      element.removeEventListener('lgAfterClose', removeGallery);
    };

    dynamicGallery.openGallery(0);
    element.addEventListener('lgAfterClose', removeGallery);
  }
};

POPUP_GALLERIES.forEach(gallery => {
  gallery.addEventListener('click', (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    const href = gallery.dataset.href || gallery.href;

    if (isImage(href)) {
      openLightGallery(gallery, [{src: href}])
    } else {
      openLightGallery(gallery, [{src: href, iframe: true}])
    }
  })
});

POPUP_AJAX_GALLERIES.forEach(gallery => {
  gallery.addEventListener('click', (evt) => {
    evt.preventDefault();
    evt.stopPropagation();

    const href = gallery.dataset.href || gallery.href;

    fetch(href, {})
      .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            console.log(response.status);
          }
        }
      )
      .then(result => {
        openLightGallery(gallery, result)
      })
  })
});

document.addEventListener('DOMContentLoaded', () => {
  if (POPUP_VIDEO) {
    lightGallery(POPUP_VIDEO, {
      speed: 500,
      plugins: [lgVideo],
      mobileSettings: {
        showCloseIcon: true
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (PAGE_GALLERY) {
    lightGallery(PAGE_GALLERY, {
      plugins: [lgZoom, lgAutoplay],
      slideShowAutoplay: 1000,
      mobileSettings: {
        showCloseIcon: true
      },
      addClass: 'ap-ignore-deep'
    });
  }
});
